<template>
  <div class="d-flex" id="wrapper">
    <UserNavigationSidebar v-if="this.userType('candidate')" :toggler.sync="isToggled" />
    <Sidebar v-if="this.userType('admin')" :toggler.sync="isToggled" />
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <TopNavbar :profile="getUserProfile" @toggled="toggleSidebarNav" />

      <Message class="mt-4" type="warning-alert" v-if="alertMessage">
        <p slot="alert-message" class="mb-0">{{ alertMessage }}</p>
      </Message>

      <div class="card">
        <section class="settings mt-5">
          <div class="col-md-7">
            <h3>Settings</h3>

            <div class="form-group row">
              <label for="date-format" class="col-sm-4 col-form-label">Date Format</label>
              <div class="col-sm-8">
                <select id="format_date" v-model="settings.dateFormat" class="form-control">
                  <option>YY-MM-DD</option>
                  <option>YY/MM/DD</option>
                  <option>DD-MM-YY</option>
                  <option>DD/MM/YY</option>
                  <option>MM-DD-YY</option>
                  <option>MM/DD/YY</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label for="time-zone" class="col-sm-4 col-form-label">Time Zone</label>
              <div class="col-sm-8">
                <v-select
                  placeholder="Select Timezone"
                  :options="getTimeZones"
                  :clearable="false"
                  v-model="selectedTimezone"
                  :reduce="zone => zone"
                  label="name"
                >
                  <template #option="{ name }">
                    {{ name }}
                  </template>
                  <template #selected-option="{ fullName, name }">
                    {{ fullName ? fullName.name : name }}
                  </template>
                </v-select>
              </div>
            </div>

            <div class="d-flex">
              <button @click="updateCandidate" class="ml-auto btn btn-primary mb-3">
                Save Changes
              </button>
            </div>

            <h3 v-if="getAccType !== 'candidate'">Email Integration</h3>
            <form @submit.prevent="connectToEmail" v-if="getAccType !== 'candidate'">
              <div class="form-group row">
                <label for="integration" class="col-sm-4 col-form-label">Email</label>

                <div class="col-sm-8">
                  <i
                    class="fas fa-plug required-fixed-right"
                    :class="emailIntegration.isEmailConnected ? 'connected' : 'disconnected'"
                  ></i>
                  <input
                    type="email"
                    class="form-control"
                    v-model="emailIntegration.email"
                    required
                  />
                </div>
              </div>

              <div class="form-group row">
                <label for="password" class="col-sm-4 col-form-label">Password</label>
                <div class="col-sm-8">
                  <input
                    class="form-control"
                    type="password"
                    v-model="emailIntegration.password"
                    required
                  />
                </div>
              </div>

              <div class="form-group d-flex">
                <button
                  v-if="emailIntegration.isEmailConnected === false"
                  type="submit"
                  class="btn btn-primary ml-auto"
                >
                  Connect
                </button>
                <button v-if="emailIntegration.isEmailConnected" class="btn btn-danger ml-auto">
                  Disconnect
                </button>
              </div>
            </form>

            <h3>Security</h3>
            <div class="form-group row">
              <label for="old" class="col-sm-4 col-form-label">Old Password</label>
              <div class="col-sm-8">
                <input
                  autocomplete="off"
                  v-model.trim.lazy="$v.form.oldPassword.$model"
                  type="password"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.form.oldPassword.$error,
                    'is-valid': !$v.form.oldPassword.$invalid,
                  }"
                  id="old"
                  placeholder="Enter old password"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="new" class="col-sm-4 col-form-label">New Password</label>
              <div class="col-sm-8">
                <input
                  autocomplete="off"
                  v-model.trim.lazy="$v.form.newPassword1.$model"
                  type="password"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.form.newPassword1.$error,
                    'is-valid': !$v.form.newPassword1.$invalid,
                  }"
                  id="new"
                  placeholder="Enter new password"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="confirm" class="col-sm-4 col-form-label">Re-type New Password</label>
              <div class="col-sm-8">
                <input
                  autocomplete="off"
                  v-model.trim.lazy="$v.form.newPassword2.$model"
                  :class="{
                    'is-invalid': $v.form.newPassword2.$error,
                    'is-valid': !$v.form.newPassword2.$invalid,
                  }"
                  type="password"
                  class="form-control"
                  id="confirm"
                  placeholder="Confirm password"
                />
              </div>
            </div>
            <div class="d-flex">
              <button @click="changePassword" class="ml-auto btn btn-primary mb-3">
                Change Password
              </button>
            </div>

            <h3>Delete account</h3>
            <div class="form-group row">
              <label for="delete" class="col-sm-4 col-form-label">Enter Password</label>
              <div class="col-sm-8">
                <input
                  type="password"
                  class="form-control"
                  id="delete"
                  placeholder="Enter password before deleting your account"
                  v-model="deletePassword"
                />
              </div>
            </div>
            <div class="d-flex">
              <button
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                class="ml-auto btn btn-danger mb-3"
                :disabled="deletePassword.length === 0"
              >
                Delete Account
              </button>
            </div>
          </div>
        </section>
        <Spinner :isLoading="isLoading" />
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">Delete Account</h1>
            <button
              ref="closeModalAcc"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            Please confirm that you want to delete your Jobshark account. This action is
            irreversible, and your data will be permanently deleted. If you have applied for any
            positions, neither Jobshark nor employers will be able to review your applications.
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button @click="deleteAcc()" type="button" class="btn btn-primary">Delete</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavbar from '@/components/Navigations/TopNavbar';
import UserNavigationSidebar from '@/components/Navigations/UserNavigationSidebar';
import Sidebar from '@/components/Navigations/Sidebar';
import Message from '@/components/AlertMessages/Message';
import { required, minLength } from 'vuelidate/lib/validators';
import { userRoleMixin } from '../../mixins/userRoleMixin';
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import Spinner from '../../components/common/LoadingSpinner/Spinner';

import { mapActions, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import axios from 'axios';
import { localStorageHelper } from '../../utils/helpers';
import { TIME_ZONES } from '../../constants';

export default {
  components: {
    Spinner,
    TopNavbar,
    Sidebar,
    UserNavigationSidebar,
    Message,
  },
  validations: {
    form: {
      oldPassword: {
        required,
        minLength: minLength(6),
      },
      newPassword1: {
        required,
        minLength: minLength(6),
      },
      newPassword2: {
        required,
        minLength: minLength(6),
      },
    },
  },
  mixins: [userRoleMixin, toggleSidebarNav],
  data: () => ({
    deletePassword: '',
    isLoading: true,
    timeZones: [],
    selectedTimezone: {},
    settings: {
      emailNotification: false,
      dateFormat: 'YY-MM-DD',
    },
    emailIntegration: {
      isEmailConnected: false,
      email: '',
      password: '',
    },
    alertMessage: '',
    form: {
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
    },
    isToggled: false,
  }),
  methods: {
    ...mapActions(['connectEmail', 'retrieveCandidateUserProfile']),
    updateCandidate() {
      axios(`${process.env.VUE_APP_API_URL}/candidate/updatesetting`, {
        method: 'post',
        data: {
          format_date: this.settings.dateFormat,
          timezone: this.selectedTimezone.timezone,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(() => {
        this.$toasted.success('Profile data saved', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      });
    },
    changePassword() {
      if (this.form.oldPassword && this.form.newPassword1 && this.form.newPassword2) {
        if (this.form.newPassword1 !== this.form.newPassword2) {
          this.$toasted.error("New password doesn't match confirm password", {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          return false;
        }
        axios(`${process.env.VUE_APP_API_URL}/auth/changepassword`, {
          method: 'post',
          data: {
            old_password: this.form.oldPassword,
            new_password: this.form.newPassword1,
            new_confirm_password: this.form.newPassword2,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-type': 'application/json',
            Accept: 'application/json',
          },
        })
          .then(() => {
            this.form.oldPassword = '';
            this.form.newPassword1 = '';
            this.form.newPassword2 = '';
            this.$toasted.success('Password changed successfully', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });
          })
          .catch(() => {
            this.$toasted.error(`There was problem changing your password.`, {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });
          });
      }
    },
    deleteAcc() {
      axios(`${process.env.VUE_APP_API_URL}/candidate/delete`, {
        method: 'delete',
        data: {
          password: this.deletePassword,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(() => {
        this.$refs.closeModalAcc.click();
        // localStorage.clear();
        localStorageHelper();
        this.$router.push('/');
      });
    },
    setSelectorOptions() {
      const selectorOptions = moment.tz
        .names()
        .reduce((memo, tz) => {
          memo.push({
            name: tz,
            offset: moment.tz(tz).utcOffset(),
          });

          return memo;
        }, [])
        .sort((a, b) => {
          return a.offset - b.offset;
        })
        .reduce((memo, tz) => {
          const timezone = tz.offset ? moment.tz(tz.name).format('Z') : '';

          return memo.concat(`${tz.name} (GMT${timezone})`);
        }, []);

      this.timeZones = selectorOptions;
    },
    setDefaultTimeZone() {
      moment.tz.setDefault(this.timezone);
    },
    connectToEmail() {
      this.connectEmail({
        email: this.emailIntegration.email,
        password: this.emailIntegration.password,
      }).then(response => {
        if (response.status == 422) {
          this.$toasted.error('Wrong email/password!', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        } else {
          this.emailIntegration.isEmailConnected = true;
          this.$toasted.success('Email connected!', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        }
      });
    },
  },
  computed: {
    ...mapGetters(['getAccType', 'getUserProfile']),
    getTimeZones() {
      return TIME_ZONES;
    },
  },
  mounted() {
    this.retrieveCandidateUserProfile().then(() => {
      this.selectedTimezone = {
        timezone: this.getUserProfile.timezone,
        name: this.getUserProfile.timezone,
        fullName: TIME_ZONES.find(item => item.timezone === this.getUserProfile.timezone),
      };
      this.settings.dateFormat = this.getUserProfile.format_date;
      this.isLoading = false;
    });
    this.setSelectorOptions();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.col-sm-8 {
  position: relative;

  .fa-plug {
    position: absolute;
    font-size: 1rem;
    top: 10px;
    right: 22px;
  }
}

.connected {
  color: $color-status-active;
}
.disconnected {
  color: $color-status-closed;
}

.disconnected {
  color: $color-status-closed;
}

.settings {
  font-family: $font-family-sans-lato;
  padding-bottom: 30px;
  padding-left: 15px;
  padding-right: 15px;

  h3 {
    font-size: 18px;
    font-weight: 700;
    border-bottom: 1px solid #ddd;
    margin: 30px 0 12px 0;
    padding-bottom: 12px;
  }
  h5 {
    font-size: 2rem;
    font-family: $font-family-sans-serif;
    margin-bottom: 22px;
  }

  .form-group {
    font-family: $font-family-sans-lato;

    .col-form-label {
      font-size: 14px;
      font-weight: 700;
    }
  }
  /* .d-flex {
    .btn:first-of-type {
      background: $color-base-blue;
      border: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .btn:nth-of-type(2) {
      background: $color-orange;
      border: none;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  } */
  /*  .btn-success {
    background: $color-base-blue;
    border-color: $color-base-blue;
  } */
}
.modal-body {
  font-size: 14px;
  padding: 20px 12px;
}
</style>
